export default class BpCalcs {
    constructor(businessPlan) {
        this.businessPlan = businessPlan;
    }

    getBuyCategory(key) {
        return this.businessPlan.buy.find(c => c.key == key);
    }

    getSellCategory(key) {
        return this.businessPlan.sell.find(c => c.key == key);
    }

    getCategoryTotal(cat, unitsMQ = false) {
        let total = 0;

        cat.fields.forEach((f) => {
            if (this.checkFieldComputedSecondary(f)) {
                total += Number(this.getComputedSecondaryValue(f));
            } else {
                total += Number(this.getFieldValue(f));
            }
        });

        if ("units" in cat) {
            cat.units.forEach((u) => {
                if (unitsMQ) {
                    total += Number(u.mq);
                    return;
                }
                total += Number(u.total);
            });
        }

        return total;
    }

    addUnitToCategory(cat) {
        cat.units.push({
            name: null,
            total: null,
            mq: null,
            new: true,
        });
    }

    getSellMargin() {
        const ricavi_vendita = this.businessPlan.sell.find((c) => c.key == "ricavi_vendita");
        const costo_commerciale_vendita = this.businessPlan.sell.find((c) => c.key == "costo_commerciale_vendita");
        return this.getCategoryTotal(ricavi_vendita) - this.getCategoryTotal(costo_commerciale_vendita);
    }

    getSellTotal() {
        return this.getSellMargin() - this.getBuyTotal();
    }

    getBuyTotal() {
        let total = 0;
        this.businessPlan.buy.forEach((c) => {
            total += this.getCategoryTotal(c);
        });
        return total;
    }

    setFieldAsEdited(field) {
        field.edited = true;
    }

    setUnitAsEdited(unit) {
        unit.edited = true;
    }

    getFieldValue(field) {
        if (field == null) return 0;
        if (field.custom_value != null) return field.custom_value;
        if (this.checkFieldComputedPrimary(field)) return this.getComputedPrimaryValue(field);
        return Number(field.value);
    }

    getComputedPrimaryValue(field) {
        const source = field.field.computed.source;
        if (!Array.isArray(source)) return this.getComputedPrimarySourceValue(source, field);
        const values = [];
        source.forEach((s) => {
            values.push(this.getComputedPrimarySourceValue(s, field));
        });
        return this.doFieldsOperation(values, field.field.computed.operator);
    }

    getComputedPrimarySourceValue(source, field) {
        const explodedSource = source.split(".");
        if (!explodedSource || explodedSource.length == 0) return null;
        if (explodedSource.length == 1) return explodedSource[0];
        if (explodedSource[0] == "model") return field.value;
        if (explodedSource[0] == "field") {
            const f = this.findField(explodedSource[1]);
            return this.getFieldValue(f);
        }
        if (explodedSource[0] == "report") {
            return field.operand_value;
        }
        if (explodedSource[0] == "category") {
            const cKey = explodedSource[1];
            let cat = this.businessPlan.buy.find((c) => c.key == cKey);
            if (!cat) cat = this.businessPlan.sell.find((c) => c.key == cKey);
            return cat == null ? 0 : this.getCategoryTotal(cat);
        }
    }

    getComputedSecondaryValue(field) {
        const explodedSource = field.field.computed.source.split(".");
        if (!explodedSource || explodedSource.length == 0) return null;
        if (explodedSource.length == 1) return explodedSource[0];
        if (explodedSource[0] == "field") {
            const f = this.findField(explodedSource[1]);
            const values = [this.getFieldValue(field), this.getFieldValue(f)];
            return this.doFieldsOperation(values, field.field.computed.operator);
        }
        if (explodedSource[0] == "report") {
            const values = [this.getFieldValue(field), field.operand_value];
            return this.doFieldsOperation(values, field.field.computed.operator);
        }
        if (explodedSource[0] == "category") {
            const cKey = explodedSource[1];
            let cat = this.businessPlan.buy.find((c) => c.key == cKey);
            if (!cat) cat = this.businessPlan.sell.find((c) => c.key == cKey);
            const values = [this.getFieldValue(field), this.getCategoryTotal(cat)];
            return this.doFieldsOperation(values, field.field.computed.operator);
        }
    }

    checkFieldComputedPrimary(field) {
        if (field.field.computed == null) return false;
        return field.field.computed.type == "primary";
    }

    checkFieldComputedSecondary(field) {
        if (field.field.computed == null) return false;
        return field.field.computed.type == "secondary";
    }

    doFieldsOperation(values, operator) {
        let value = 0;
        switch (operator) {
            case "%":
                value = values[0] * values[1] * 0.01;
                break;

            case "*":
                value = values.reduce(function (oldVal, newVal) {
                    oldVal = oldVal == null ? 1 : oldVal;
                    return oldVal * newVal;
                });
                break;

            case "+":
                value = values.reduce(function (oldVal, newVal) {
                    return oldVal + newVal;
                });
                break;

            case "-":
                value = values[0] - values[1];
                break;

            case "/":
                value = values[0] / values[1];
                break;
        }
        return value;
    }

    findField(fieldKey) {
        let f = null;

        this.businessPlan.buy.forEach((cat) => {
            cat.fields.forEach((field) => {
                if (field.field.name == fieldKey) f = _.cloneDeep(field);
            });
        });
        if (f !== null) return f;

        this.businessPlan.sell.forEach((cat) => {
            cat.fields.forEach((field) => {
                if (field.field.name == fieldKey) f = _.cloneDeep(field);
            });
        });

        return f;
    }
}
